// Calcolatore a cascata — barra fissa con i totali dell'intera catena (ricavi finali, costi di tutti gli stadi, margine)
import React from "react";
import { fmtEur, fmtPct, fmtKg } from "../prodApi";
import { toneOf } from "./ui";

export const CascadeSummary = ({ totals, input, loading, stages }) => {
  if (!totals) return null;
  const cells = [
    ["Fatturato finale", fmtEur(totals.revenue_total), `${fmtKg(totals.sellable_kg, 1)} kg venduti · resa ${fmtPct(totals.yield_final_pct)}`, "text-white", "casc-sum-revenue"],
    ["Costi totali", fmtEur(totals.cost_total), `materia ${fmtEur(totals.input_cost)} · lavorazioni ${fmtEur(totals.processing + totals.ingredients)}`, "text-white", "casc-sum-cost"],
    ["Margine", fmtEur(totals.margin), `${fmtPct(totals.margin_pct)} sul fatturato · ${fmtEur(totals.margin_per_kg_input)}/kg in ingresso`, toneOf(totals.margin), "casc-sum-margin"],
    ["Vs vendita diretta", `${totals.margin_delta_processing >= 0 ? "+" : ""}${fmtEur(totals.margin_delta_processing)}`, stages > 1 ? `${stages} lavorazioni · ${fmtKg(totals.labour_hours, 1)} ore uomo` : "aggiungi lavorazioni sotto i tagli", toneOf(totals.margin_delta_processing), "casc-sum-delta"],
  ];
  return (
    <div className={`sticky top-[7.25rem] md:top-32 z-30 -mx-3 md:mx-0 px-3 md:px-0 py-2 bg-[#0F172A]/95 backdrop-blur transition-opacity ${loading ? "opacity-70" : ""}`} data-testid="casc-summary">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
        {cells.map(([l, v, s, c, tid]) => (
          <div key={l} className="bg-slate-800/80 border border-slate-700 rounded-xl px-3 py-2" data-testid={tid}>
            <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">{l}</p>
            <p className={`font-['Chivo'] font-black text-lg md:text-2xl tabular-nums leading-tight ${c}`}>{v}</p>
            <p className="text-[10px] md:text-[11px] text-slate-500 truncate">{s}</p>
          </div>
        ))}
      </div>
      {input && <p className="text-[11px] text-slate-500 mt-1 tabular-nums">{input.node_name} · {fmtKg(input.pieces, 0)} pz · {fmtKg(input.total_kg, 0)} kg a {fmtEur(input.cost_per_kg_effective)}/kg effettivi</p>}
    </div>
  );
};
